module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-pop-layer"
  }, [_c('div', {
    staticClass: "m-flex-row"
  }, [_c('div', {
    staticClass: "m-pop-content cicc"
  }, [(_vm.payResult === 'success') ? _c('div', {
    staticClass: "m-pop-res"
  }, [_c('img', {
    staticClass: "m-pop-icon",
    attrs: {
      "src": require("../../assets/icons/success.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "m-pop-title-cicc"
  }, [_vm._v("支付成功")]), _vm._v(" "), _c('p', {
    staticClass: "m-pop-des-cicc"
  }, [_vm._v("恭喜您，已成功完成支付")])]) : (_vm.payResult === 'warning') ? _c('div', {
    staticClass: "m-pop-res"
  }, [_c('img', {
    staticClass: "m-pop-icon",
    attrs: {
      "src": require("../../assets/icons/warning.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "m-pop-title-cicc"
  }, [_vm._v("支付超时")]), _vm._v(" "), _c('p', {
    staticClass: "m-pop-des-cicc"
  }, [_vm._v("订单超时，请重新支付")]), _vm._v(" "), _c('p', {
    staticClass: "m-pop-btn-cicc",
    on: {
      "click": _vm.rePay
    }
  }, [_vm._v("重新支付")])]) : (_vm.payResult === 'fail') ? _c('div', {
    staticClass: "m-pop-res"
  }, [_c('img', {
    staticClass: "m-pop-icon",
    attrs: {
      "src": require("../../assets/icons/fail.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "m-pop-title-cicc"
  }, [_vm._v("支付失败")]), _vm._v(" "), (_vm.failReason.length) ? _c('p', {
    staticClass: "m-pop-des-cicc"
  }, [_vm._v("\n          失败原因：" + _vm._s(_vm.failReason || "") + "\n        ")]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "m-pop-btn-cicc",
    on: {
      "click": _vm.rePay
    }
  }, [_vm._v("重新支付")])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c4bd718a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/agent/pay-finish-cicc.vue
// module id = 658
// module chunks = 1